
import { Link } from "react-router-dom";
import { RelatedImagesGrid } from "./RelatedImagesGrid";

interface RelatedPinsProps {
  pins: any[];
}

export function RelatedPins({ pins }: RelatedPinsProps) {
  if (!pins || pins.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4 max-w-screen-xl mx-auto">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-medium">Mais como este</h3>
        {pins.length > 6 && (
          <Link to="/" className="text-sm text-primary hover:underline">
            Ver mais
          </Link>
        )}
      </div>
      
      <RelatedImagesGrid pins={pins} />
    </div>
  );
}
